import { APIS } from "../endpoints";
import api from "../services/api";

export const getDeriveFileData = async (page,limit,searchText) => {
const formData = new FormData();
    formData.append('page', page);
    formData.append('limit', limit);

    if (searchText) {
        formData.append('search', searchText); // Add search term
    }
   const params = new URLSearchParams(formData);

    const result = await api.get(`${APIS.BASE_URL}${APIS.adminDerive}`, {
        params: params
    });

    if (result) {
        return result?.data;
    } else {
        return [];
    }
};

export const uploadFile = async (data) => {
  try {
    const formData = new FormData();
    formData.append("objectFile", data);

    const result = await api.post(`${APIS.BASE_URL}${APIS.adminDerive}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return result || [];
  } catch (error) {
    console.error("Upload failed:", error);
    return [];
  }
};
